// BlogHome.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logoBanner from "../assets/images/new_logo_without_font.png";
import HighPerformanceAd from "../components/HighPerformanceAd";
import optionsImage from "../assets/images/why_be_trader.png";

export default function BlogHome() {

  useEffect(() => {
    document.title = "Blogs | CoinzUp";
  }, []);


  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-x-hidden">
      <header className="border-b border-gray-800 px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/index">
          <img src={logoBanner} alt="CoinZUp Logo" className="w-32 sm:w-40 h-auto" />
        </Link>
        <div className="space-x-3 sm:space-x-4 text-sm sm:text-base">
          <Link to="/blog" className="hover:underline">Blog</Link>
          <Link to="/login" className="hover:underline">Log In</Link>
          <Link to="/register" className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition">Sign Up</Link>
        </div>
      </header>

          {/* 🄸🄵🅁🄰🄼🄴 🔽 always visible and responsive */}
    <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90}/>

      <div className="bg-gray-950 text-white px-4 py-12 sm:px-6 lg:px-12 max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-yellow-400 mb-6">📰 CoinzUp Blog</h1>
        
        <div className="mb-12">
        <h2 className="text-2xl font-bold text-white-500 mb-2">
            <Link to="/blog/newcrypto">  New cryptos added to CoinzUp</Link>
          </h2>
          
          <p className="text-gray-400 mb-2">
          Why Convert Your Coinz into Ethereum, Solana, and WAVES?
          </p>
          <Link to="/blog/newcrypto" className="text-yellow-400 hover:underline">Read more →</Link>
        </div>

        <div className="mb-12">
        <h2 className="text-2xl font-bold text-white-500 mb-2">
            <Link to="/blog/autosurf">  Earn Coinz Effortlessly with AutoSurf</Link>
          </h2>
          
          <p className="text-gray-400 mb-2">
            Discover how your actions — logging in, playing, trading — contribute to passive income through dividends.
          </p>
          <Link to="/blog/autosurf" className="text-yellow-400 hover:underline">Read more →</Link>
        </div>

        <div className="mb-12">
        <h2 className="text-2xl font-bold text-white-500 mb-2">
            <Link to="/blog/owingoptions"> Why Owning Options on CoinzUp is a Long-Term Win</Link>
          </h2>
         
          <p className="text-gray-400 mb-2">
          What if you could earn money just by staying connected?
          </p>
          <Link to="/blog/owingoptions" className="text-yellow-400 hover:underline">Read more →</Link>
        </div>

        <div className="mb-12">
          <h2 className="text-2xl font-bold text-white-500 mb-2">
            <Link to="/blog/welcome"> Welcome to the Official CoinzUp Blog</Link>
          </h2>
          <p className="text-gray-400 mb-2">
            Your hub for platform news, features, and tips to maximize your earnings on CoinzUp.
          </p>
          <Link to="/blog/welcome" className="text-yellow-400 hover:underline">Read more →</Link>
        </div>
      </div>

      <footer className="bg-gray-900/80 text-center text-sm text-gray-500 py-4 border-t border-gray-800 space-x-2">
        © 2025 CoinzUp.net. All rights reserved.
        <Link to="/notice" className="hover:text-white underline">Privacy & Legal Notice</Link>
        <Link to="/terms" className="hover:text-white underline">Terms & Conditions</Link>
      </footer>
    </div>
  );
}
